import React, { useRef, useState } from "react";
import { Button } from "@blueprintjs/core";

export default function TestSound() {
  const audioRef = useRef();
  const [playing, setPlaying] = useState(false);

  return (
    <div>
      <Button
        icon={playing ? "volume-up" : "volume-off"}
        intent="primary"
        style={{ borderRadius: "200px" }}
        onClick={() => {
          if (playing) {
            setPlaying(false);
            audioRef.current.pause();
          } else {
            setPlaying(true);
            audioRef.current.currentTime = 0;
            audioRef.current.play();
          }
        }}
      />
      <audio
        src="sound/sonar.ogg"
        ref={audioRef}
        autoPlay={false}
        onEnded={() => {
          setPlaying(false);
        }}
      />
    </div>
  );
}
